module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "main-dialog",
    attrs: {
      "title": undefined,
      "show-close": false,
      "visible": _vm.visible && !!_vm.data,
      "top": '10vh',
      "width": _vm.isDesktop ? '70%' : '90%',
      "before-close": _vm.onClose
    }
  }, [_c('div', {
    staticClass: "el-dialog__content",
    staticStyle: {
      "max-width": "930px",
      "margin-left": "auto",
      "margin-right": "auto",
      "text-align": "center"
    }
  }, [_c('h1', {
    staticStyle: {
      "padding-bottom": "1em",
      "font-size": "1.4em"
    }
  }, [_vm._v(_vm._s(_vm.data.title))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "left",
      "padding-left": "30px",
      "padding-right": "30px"
    }
  }, [(_vm.data.content) ? _c('markdown', {
    attrs: {
      "source": _vm.data.content
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer",
      "align": "center"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "button is-primary",
    staticStyle: {
      "margin-bottom": "15px",
      "margin-right": "-10px"
    },
    on: {
      "click": _vm.onClose
    }
  }, [_c('span', {
    staticStyle: {
      "text-transform": "uppercase"
    }
  }, [_vm._v("Close")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ac6b2a6a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainDialog.vue
// module id = 988
// module chunks = 1